import React, {useEffect, useState} from "react";
import {useDropzone} from "react-dropzone";
import classNames from "classnames";
import Icon, {trashIcon, uploadIcon} from "../Icon/Icon";
import Button from "../Button/Button";
import InputWrapper from "./InputWrapper";
import imageActions from "../../api/ImagesActions";
import applicationConfiguration from "../../config/applicationConfiguration";

const PictureDrop = ({formik, name, label, required = false, layout = "horizontal"}) => {
    const [preview, setPreview] = useState(null);

    const url = formik.values[name]?.url;
    const fieldError = formik.touched[name] && formik.errors[name];

    const {getRootProps, getInputProps, isDragActive} = useDropzone({
        multiple: false,
        maxFiles: 1,
        onDrop: acceptedFiles => {
            if (acceptedFiles.length > 0) {
                imageActions.uploadImage(acceptedFiles[0], res => {
                    formik.setFieldValue(name, res);
                    formik.setFieldTouched(name, true, false);
                });
            }
        }
    });

    useEffect(() => {
        const baseUrl = (applicationConfiguration.apiUrl ?? "").replace(/\/+$/, "");
        setPreview(url ? `${baseUrl}/api/avatars/${url}` : null);
    }, [url]);

    const handleRemove = (e) => {
        e.preventDefault();
        e.stopPropagation();
        formik.setFieldValue(name, null);
        formik.setFieldTouched(name, true, false);
    };

    return (
        <InputWrapper
            name={name}
            label={label}
            formik={formik}
            required={required}
            layout={layout}
            inputWrapperClassName="dropzone"
        >
            <div
                {...getRootProps()}
                className={classNames("dnd", {
                    "active": isDragActive,
                    "has-error": fieldError,
                })}
            >
                <input {...getInputProps({id: name})}/>

                {preview ? (
                    <>
                        <Button variant="action">
                            <Icon svg={trashIcon} onClick={handleRemove}/>
                        </Button>
                        <img src={preview} alt="preview" className="preview"/>
                    </>
                ) : (
                    <>
                        <Icon svg={uploadIcon} className="upload"/>
                        <span>Click to Upload or drag and drop</span>
                    </>
                )}
            </div>
        </InputWrapper>
    );
};

export default PictureDrop;